/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPagingResponseOfAllotmentWithFareFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, serializePagingResponseOfAllotmentWithFare, type AgGridClientQuery, type PagingResponseOfAllotmentWithFare, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/Get
 */
export interface GetRequestBuilder extends BaseRequestBuilder<GetRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagingResponseOfAllotmentWithFare>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<GetRequestBuilderPostQueryParameters> | undefined) : Promise<PagingResponseOfAllotmentWithFare | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<GetRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface GetRequestBuilderPostQueryParameters {
    isActive?: boolean;
    showUpToDate?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const GetRequestBuilderUriTemplate = "{+baseurl}/Allotment/Get?isActive={isActive}&showUpToDate={showUpToDate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GetRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagingResponseOfAllotmentWithFareFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
